<template>
	<div>
		<app-ad></app-ad>

		<div>
			<v-container class="pt-0">
				<v-row class="pt-0">
					<v-col cols="12" class="pt-0">
						<v-breadcrumbs :items="breadcrumbs">
							<template #divider>
								<v-icon>mdi-chevron-left</v-icon>
							</template>
						</v-breadcrumbs>
					</v-col>
				</v-row>
				
				<v-row justify="center">
					<v-col
						v-for="fav in favorite"
						:key="fav.relatedModel + fav.relatedID"
						cols="10"
						sm="6"
						md="6"
						lg="4"
					>
						<v-hover v-slot="{ hover }">
							<v-card :elevation="hover ? 6 : 2" class="pb-0 pt-0" style="height: 100%;">
								<v-row no-gutters justify="center" align="center">
									<v-col cols="10" class="text-start ps-2">
										<v-icon v-if="fav.relatedModel=='courses'" right>mdi-teach</v-icon>
										<v-icon v-else-if="fav.relatedModel=='news'" right>mdi-newspaper</v-icon>
										<v-icon v-else-if="fav.relatedModel=='events'" right>mdi-account-switch</v-icon>
										<v-icon v-else-if="fav.relatedModel=='jobs'" right>mdi-doctor</v-icon>
										<v-icon v-else-if="fav.relatedModel=='library'" right>mdi-library</v-icon>
										{{ fav.relatedModelAR }}
									</v-col>
									<v-col cols="2" class="text-end">
										<v-menu nudge-right="30" nudge-bottom="30" content-class="elevation-1">
											<template #activator=" { on:menu } ">
												<v-tooltip bottom>
													<template #activator=" { on:tooltip } ">
														<v-btn icon v-on="{ ...tooltip, ...menu }">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<span>مشاركة المحتوى</span>
												</v-tooltip>
											</template>
											<v-list dense nav>
												<v-list-item @click="deleteFromFavorite(fav.favoritID)">
													<v-icon size="26">mdi-bookmark-remove</v-icon>
												</v-list-item>
												
												<!-- :description="fav.note" -->
												<ShareNetwork 
													v-for="network in networks"
													:key="network.id"
													:network="network.id" 
													:url="fav.url"
													:title="fav.title"
													hashtags="e_ritqa"
													twitter-user="e_ritqa"
												>
													<v-list-item @click=";">
														<v-icon size="26">{{ network.icon }}</v-icon>
													</v-list-item>
												</ShareNetwork>
											</v-list>
										</v-menu>
									</v-col>
								</v-row>

								<v-row justify="center">
									<v-col cols="12" class="text-center py-2 px-4">
										<router-link
											v-if="fav.relatedModel=='courses'"
											class="black--text"
											:to="{ name: 'course' , params: { courseID: fav.relatedID}}"
										>
											<h4>{{ fav.title }}</h4>
										</router-link>
										<router-link
											v-else-if="fav.relatedModel=='news'"
											class="black--text"
											:to="{ name: 'news-item' , params: { recordID: fav.relatedID}}"
										>
											<h4>{{ fav.title || fav.relatedModel }}</h4>
										</router-link>
										<router-link
											v-else-if="fav.relatedModel=='events'"
											class="black--text"
											:to="{ name: 'event' , params: { recordID: fav.relatedID}}"
										>
											<h4>{{ fav.title || fav.relatedModel }}</h4>
										</router-link>
										<router-link
											v-else-if="fav.relatedModel=='jobs'"
											class="black--text"
											:to="{ name: 'job' , params: { jobID: fav.relatedID}}"
										>
											<h4>{{ fav.title || fav.relatedModel }}</h4>
										</router-link>
										<router-link
											v-else-if="fav.relatedModel=='library'"
											class="black--text"
											:to="{ name: 'library-item' , params: { recordID: fav.relatedID}}"
										>
											<h4>{{ fav.title || fav.relatedModel }}</h4>
										</router-link>
									</v-col>
									<v-col cols="auto" class="text-start mx-2">
										<span color="primary">
											<v-icon right>mdi-calendar</v-icon>
											{{ fav.publishDate ? fav.publishDate.substring(0,10) : "-" }}
										</span>
									</v-col>
									<v-spacer></v-spacer>
									<v-col v-if="configViewCount" cols="auto" class="text-end mx-2">
										<span>{{ fav.viewCount }}</span>
										<v-icon left>mdi-eye</v-icon>
									</v-col>
								</v-row>
							</v-card>
						</v-hover>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<app-ad></app-ad>

		<app-sponsors></app-sponsors>
	</div>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	components: {
		"app-sponsors": require("@/components/general/AppSponsors").default,
		//"app-contact-us": require("@/components/general/AppContactUs").default,
		"app-ad": require("@/components/general/AppAd").default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'الرئيسية', to: { name: "home" }, exact: true },
				{ text: 'المفضلة', disabled: true }
			],
			page: 1,
			pageCount: 1,
			favorite: [],
			state: 0,
			networks: [
				{
					id: "facebook",
					icon: "mdi-facebook"
				},
				{ 
					id: "telegram",
					icon: "mdi-telegram"
				},
				{ 
					id: "twitter",
					icon: "mdi-twitter"
				},
				{ 
					id: "whatsapp",
					icon: "mdi-whatsapp"
				},
				{ 
					id: "email",
					icon: "mdi-email"
				},
			],
		}
	},
	computed: {
		configViewCount() {
			return this.$store.state.viewCount;
		},
		base(){
			return location.origin;
		}
	},
	mounted() {
		this.getFav();
	},
	methods: {
		getFav() {
			client
				.get("/api/favorite/all")
				.then(response => {
					console.log(response);
					this.favorite = Object.values(response.data.data.data).map(
						fav => {
							var route = {};
							if (fav.relatedModel == "courses") {
								route = {
									name: "course",
									params: { courseID: fav.relatedID }
								};
								route = this.$router.matcher.match(route)
									.fullPath;
								fav.url = document.location.origin + route;
							} else if (fav.relatedModel == "news") {
								route = {
									name: "news-item",
									params: { recordID: fav.relatedID }
								};
								route = this.$router.matcher.match(route)
									.fullPath;
								fav.url = document.location.origin + route;
							} else if (fav.relatedModel == "events") {
								route = {
									name: "event",
									params: { recordID: fav.relatedID }
								};
								route = this.$router.matcher.match(route)
									.fullPath;
								fav.url = document.location.origin + route;
							} else if (fav.relatedModel == "jobs") {
								route = {
									name: "job",
									params: { jobID: fav.relatedID }
								};
								route = this.$router.matcher.match(route)
									.fullPath;
								fav.url = document.location.origin + route;
							} else if (fav.relatedModel == "library") {
								route = {
									name: "library-item",
									params: { recordID: fav.relatedID }
								};
								route = this.$router.matcher.match(route)
									.fullPath;
								fav.url = document.location.origin + route;
							}
							return fav;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		deleteFromFavorite(id) {
			clientNotifier
				.delete("/api/favorite/delete/" + id)
				.then((response) => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.favorite.findIndex(fav => {
						return fav.favoritID == id;
					});

					if (index != -1) {
						this.favorite.splice(index, 1);
					}
				})
		}
	}
};
</script>

<style scoped>
.sponsor {
	filter: grayscale(100%);
	opacity: 0.4;
	transition: 500ms;
}

.sponsor:hover {
	filter: grayscale(0);
	opacity: 1;
	transform: scale(1.05);
}

.zoom ::v-deep .v-image__image {
	transform: scale(1.5);
}
</style>